import CardSolution from './CardSolution'

/**
 * Componente que renderiza una lista de soluciones técnicas.
 * * Actúa como un contenedor iterativo que proyecta cada elemento del arreglo `items`
 * en un componente `CardSolution`. Gestiona la distribución vertical de las tarjetas
 * y propaga los eventos de interacción.
 * * @component
 * @param {Object} props - Propiedades del componente.
 * @param {Array<Object>} [props.items=[]] - Arreglo de objetos que contienen la información de cada solución.
 * @param {Function} props.onDelete - Callback que se dispara cuando se confirma la eliminación de una solución en la tarjeta. Recibe el ID del elemento.
 * * @returns {JSX.Element} Un fragmento que contiene la lista mapeada de soluciones.
 */
const ListSolution = ({ items = [], onDelete }) => {
  return (
    <>
      <div>
        {items.map((i, index) => (
          <CardSolution key={index} data={i} onDelete={onDelete} />
        ))}
      </div>
    </>
  )
}

export default ListSolution
